module.exports = __webpack_public_path__ + "static/media/light_ru.1b914de6.svg";